import Touchdown from "../../../../football/rules/general/scoring/touchdown";
import DriveEndType from "../../../../football/enums/drive-end-type";

export default class FlagTouchdown extends Touchdown {
    kickoffContextChanges() {}
    flagChanges(gameContext) {
        gameContext.triggerPAT = true;
        gameContext.setDriveContext({
            previousDriveEndType: DriveEndType.Touchdown
        });
    }
}
